<template>
  <div>
    <div
      v-for="field in section.nonElementFields"
      :key="`${field.id}-${dropdownControlId}`"
    >
      <field-item
        :disabled="handler.isDisabled(field, parentTreeContext)"
        @click="select(field.select(field, section.workflowStep))"
      >
        <row>
          <prefix>
            <icon :glyph="modelTypeIcon(field.modelType)"/>
          </prefix>

          <column>
            {{ field.label }}
          </column>
        </row>
      </field-item>
    </div>

    <template v-if="!handler.hideWorkflowStepData">
      <strong class="crayon red">Default Workflow Data</strong>

      <div v-for="element in section.dateOptions" :key="element.id">
        <button
          @click="select(element.select(element))"
          type="button"
          class="field-item"
          :class="{'disabled-link': handler.isDisabled(element, parentTreeContext)}"
          :disabled="handler.isDisabled(element, parentTreeContext)"
        >
          <row>
            <prefix>
              <icon glyph="datepicker" />
            </prefix>

            <column>
              {{element.label}}
            </column>
          </row>
        </button>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import handlerComponentsMixin from '~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin';
  import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin';
  import FormElementDynamicFieldsHandler from '~/models/dynamicFields/handlers/formElementDynamicFieldsHandler';
  import { IFormDynamicFieldSection } from '~/interfaces/dynamicFieldsInterfaces';

  export default Vue.extend({
    mixins: [
      handlerComponentsMixin,
      handlerTreeContextMixin,
    ],
    props: {
      handler: {
        type: Object as () => FormElementDynamicFieldsHandler,
        required: true,
      },
      section: {
        type: Object as () => IFormDynamicFieldSection,
        required: true,
      },
    },
  })
</script>